<!-- 
    FORM VISUALIZACAO DO LEAD
-->

<script>
import Vue from 'vue';
import { apiORDSpost, apiORDSdelete, apiDownloadPDF, apiEmailPDF } from '../shared/api-functions'
import { SysVars } from '../main';
import apiCrm from '../api/api-crm.js'
import CrmLeadNovoForm from './crm-lead-novo-form'
import CrmNegocioNovoForm from './crm-negocio-novo-form'
import CrmNegocioAgenda from './crm-negocio-agenda'
import CrmNotes from './crm-notes'

export default {
    props: {
        index: '',
    },

    components: {
        CrmNegocioNovoForm, CrmLeadNovoForm, CrmNegocioAgenda, CrmNotes
    },

    data () {
        return {
            errmessages: null,
            error: false,
            metadata: this.$store.getters.getEntities.metadata,
            modalDelete: false,
            activeTab: 0,

            showFormNegocio: false,
            showFormLead: false,

            leadcrm: null,

            paramsNegocio: null,

            notes: [],
            addingNote: false,

            indexNote: null,
            texto: null,

        }
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    computed: {
        permiteAlteracao: function () {
            return this.leadcrm.stlead=='A' && this.leadcrm.excluido!='S'
        },
        nomeUsuario: function () {
            if (this.leadcrm && this.leadcrm.usuario.length > 0)
              return this.leadcrm.usuario[0].nome
            else 
              return null
        },

        organizacao: function () {
            if (this.leadcrm && this.leadcrm.organizacao.length > 0)
              return this.leadcrm.organizacao[0]
            else 
              return null
        },

        tag: function () {
            if (this.leadcrm && this.leadcrm.tag.length > 0)
              return this.leadcrm.tag[0]
            else 
              return null
        },

        agendaList: function () {
            return this.leadcrm.agenda.filter((obj) => {
                return obj.concluida === 'S'
            })
        },

        agendaListPlanejada: function () {
            return this.leadcrm.agenda.filter((obj) => {
                return obj.concluida != 'S'
            })
        },

    },

    methods: {
        changeTab (idx) {
            this.activeTab = idx
        },

        handleStyle(color) {
            if (color)
              return 'color: white; background-color: ' + color;
            else 
              return ''
        },

        closeFormOrg (organizacao) {
            this.showFormOrg = false
            if (this.organizacao) {
                this.loadData()
            }
        },

        handleExcluir () {
            if (confirm("Confirma a exclusão?")) {
                this.apiLeadDelete(this.leadcrm.codlead, this.callBackLead)
            }
        },

        handleReabrir () {
            let obj = { codlead: this.leadcrm.codlead, excluido: 'N' }
            this.apiLead(obj, this.leadcrm.codlead, this.callBackLead)
        },

        callBackLead (data) {
            if (data) {
                this.leadcrm = data
            }
        },

        closeForm () {
            if (this.$route.params.id)
                this.$router.go(-1)
            else
                this.$emit('closeform')
        },

        loadEmails () {
            this.showCodemail = null
            this.$store.dispatch('loadNegocioEmails', { id: this.leadcrm.codnegocio } )
        },

        async loadData () {
            await this.$store.dispatch('loadConfigCrm', this)
            let codlead = this.index
            if (this.$route.params && this.$route.params.id)
              codlead = this.$route.params.id
            await this.$store.dispatch('loadLead', { id: codlead } )
            if (this.$store.getters.getLeadCrm) {
                this.leadcrm = {...this.$store.getters.getLeadCrm}
                this.notes = this.leadcrm.notes
            }
        },

        handleEditar () {
            this.showFormLead = true
        },

        closeFormNegocio (data) {
            console.log(data)
            this.showFormNegocio = false
            if (data)
              this.closeForm()
        },

        closeFormLead (data) {
            this.showFormLead = false
            if (data)
              this.leadcrm = data
        },

        handleTransformToDeal () {
            //CRIA UM NEGOCIO ATRAVÉS DO LEAD
            this.paramsNegocio = { lead: this.leadcrm }
            this.showFormNegocio = true;
        },

        handleArquivar () {
            let obj = { codlead: this.leadcrm.codlead, stlead: 'F' }
            this.apiLead(obj, this.leadcrm.codlead, this.callBackLead)
        },

        /////////////////////////////////// ATIVIDADES  / AGENDA
        handleIncluirAgenda (codagenda) {
            //abre a tela de edicao
            this.$refs.agenda.handleIncluirAgenda()
        },
        updateAgenda (agenda) {
            // this.tabs[3].count = this.agendaList.length
        },
        /////////////////////////////////// FIM ATIVIDADES


    },

    watch: {

    },

    mounted () {
        this.$nextTick(function () {
        })
    },

    created () {
        this.loadData()
    }

}

</script>

<template>

<div id="formorg" class="deal-form" v-if="leadcrm">
    <div class="deal-form-1">
        <div class="deal-form-2">
            <div class="deal-form-3">
                <div class="deal-form-left">
                    <div class="row">
                        <div class="col-12 mt-2">
                            <span class="lbl-deal-title" style="cursor: pointer" @click="handleEditar">{{ leadcrm.titulo}}</span>
                            <span v-if="leadcrm.excluido=='S'" class="badge badge-red">Excluído</span>
                            <span v-if="leadcrm.stlead=='F'" class="badge badge-yellow">Arquivado</span>
                            <v-button v-if="permiteAlteracao" class="float-right" label="" title="Gerar um negócio" icon="fa-dollar" :success="true" @click="handleTransformToDeal"></v-button>
                            <v-button v-if="permiteAlteracao" class="float-right" label="" title="Arquivar este lead" icon="fa-dropbox" @click="handleArquivar"></v-button>
                            <v-button v-if="permiteAlteracao" class="float-right" label="" title="" icon="fa-pencil" @click="handleEditar"></v-button>
                        </div>
                        <div class="col-12 mt-2">
                            <div class="w-100">
                                <span class="lbl-list"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> Criado em {{ leadcrm.data | formatDataHoraExtenso }}</span>
                            </div>
                        </div>
                        <div class="col-12 mt-3" v-if="permiteAlteracao">
                            <v-button v-if="!leadcrm.valor" :link="true" label="Valor Não Definido" @click="handleEditar"></v-button>
                            <span v-else class="lbl-negocio" style="cursor: pointer" @click="handleEditar"> {{ leadcrm.valor | formatValue(2) }} </span>
                        </div>
                        <!-- ETIQUETA -->
                        <div class="col-12 mt-3" v-if="permiteAlteracao">
                            <div v-if="leadcrm.tag.length>0">
                                <i class="lbl-deal-subtitle fa fa-tag pr-2" aria-hidden="true"></i> 
                                <span class="tag-input-color" :style="handleStyle(leadcrm.tag[0].cor)" @click="handleEditar">{{ leadcrm.tag[0].descricao }} </span>
                            </div>
                            <v-button v-else :link="true" label="Definir uma etiqueta" icon="fa-tag" @click="handleEditar"></v-button>
                        </div>
                        <!-- CONTATO -->
                        <div class="col-12 mt-5">
                            <div class="mb-2">
                                <span class="lbl-deal-subtitle">PESSOA DE CONTATO</span>
                            </div>
                            <div class="w-100">
                                <i class="fa fa-user pr-2" aria-hidden="true" style="font-size: 18px"></i>
                                <span class="lbl-subtitle pr-2"> {{ leadcrm.pessoanome }} </span>
                            </div>
                            <div class="w-100"></div>
                            <span class="lbl-list"><i class="fa fa-phone pr-2" aria-hidden="true"></i> {{ leadcrm.fonenumero | formatFone }} </span>
                            <div class="w-100"></div>
                            <span class="lbl-list"><i class="fa fa-envelope pr-2" aria-hidden="true"></i> {{ leadcrm.email }} </span>
                        </div>
                        <!-- ORGNIZACAO -->
                        <div class="col-12 mt-5">
                            <div class="mb-2">
                                <span class="lbl-deal-subtitle">ORGANIZAÇÃO</span>
                            </div>
                            <div class="w-100">
                                <i class="fa fa-university pr-2" aria-hidden="true" style="font-size: 18px"></i>
                                <span class="lbl-subtitle pr-2"> {{ leadcrm.orgnome }} </span>
                            </div>
                        </div>
                        <!-- PROPRIETARIO -->
                        <div class="col-12 mt-5">
                            <div class="mb-2">
                                <span class="lbl-deal-subtitle mb-2">PROPRIETÁRIO</span>
                            </div>
                            <div>
                                <a class="lbl pr-2"><i class="fa fa-user-circle pr-2" aria-hidden="true"></i> {{ nomeUsuario }}</a>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="deal-form-right">
                    <div class="sticky">
                        <button type="button" class="close" style="" @click="closeForm()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div style="overflow-x: auto; height: 100%;">
                        <div class="mt-1">
                            <crm-notes :params="{ codlead: leadcrm.codlead, notes: notes }"></crm-notes>
                        </div>
                        <div class="mt-5">
                            <span class="lbl-deal-subtitle mb-2"><i class="fa fa-calendar pr-2"></i>ATIVIDADES PLANEJADAS</span>
                            <v-button :link="true" label="Criar uma atividade" icon="fa-plus" @click="handleIncluirAgenda"></v-button>
                        </div>
                        <crm-negocio-agenda ref="agenda" 
                            :params="{ lead: leadcrm, listAgenda: leadcrm.agenda, listAgendaShow: agendaListPlanejada, delete: true, edit: true }"
                            @update="updateAgenda" @delete="updateAgenda"></crm-negocio-agenda>
                        <div class="mt-5" v-if="agendaList.length > 0">
                            <span class="lbl-deal-subtitle mb-2"><i class="fa fa-calendar pr-2"></i>ATIVIDADES CONCLUÍDAS</span>
                        </div>
                        <crm-negocio-agenda ref="agenda" v-if="agendaList.length > 0" 
                            :params="{ lead: leadcrm, listAgenda: leadcrm.agenda, listAgendaShow: agendaList, delete: true, edit: true }"
                            @update="updateAgenda" @delete="updateAgenda"></crm-negocio-agenda>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <crm-negocio-novo-form v-if="showFormNegocio" :params="paramsNegocio" @closeform="closeFormNegocio"></crm-negocio-novo-form>
    <crm-lead-novo-form v-if="showFormLead" :index="leadcrm.codlead" @closeform="closeFormLead"></crm-lead-novo-form>

</div>





</template>

<style scoped>


</style>


// WEBPACK FOOTER //
// src/forms-crm/crm-lead-form.vue